let host = "//uc.api.hxylt.org.cn";
let env = "production";

if (process.env.NODE_ENV == "local") {
  host = "//uc.api.doclive.cn";
  env = "local";
} else if (process.env.NODE_ENV == "development") {
  host = "//uc.api.doclive.cn";
  env = "development";
} else if (process.env.NODE_ENV == "production") {
  host = "//uc.api.hxylt.org.cn";
  env = "production";
}
export { host, env };
